import React, { useEffect, useState } from "react";
import axios from "axios";
import { toastNotify } from "../utils/Utils";
import { useNavigate } from "react-router-dom";
import LogoDompetKartini from "../assets/images/dompet-vert.png";
import useWindowSize from "../hooks/useWindowSize";
import ModalBasic from "../components/ModalBasic";
import ModalLoading from "../components/ModalLoading";
import { isValidEmail } from "../utils/Utils";
import { requestAuthPost } from "../api/authInstance";
import withAuth from "../components/withAuth";
import _ from "lodash";
import InformationSheet from "../components/Sheet/InformationSheet";
import SwitchLang from "../components/SwitchLang";
import SigninTabs from "../components/Tabs/SigninTabs";
import { useAuth } from "../components/auth/authContext";
import { useTranslation } from "react-i18next";
import KartiniCopyright from "../components/KartiniCopyright";
import { Helmet } from "react-helmet";
import DompetVersion from "../components/DompetVersion";

const Signin = () => {
  const { fetchAuthData } = useAuth();
  const { width } = useWindowSize();
  const [email, setEmail] = useState(localStorage.getItem("DK_email") || "");
  const [whatsappNum, setWhatsappNum] = useState("");
  const [otp, setOtp] = useState("");
  const [counter, setCounter] = useState(
    Number(localStorage.getItem("countdown")) > Date.now()
      ? Number(localStorage.getItem("countdown"))
      : 0,
  );
  const [isSent, setIsSent] = useState(
    (localStorage.getItem("DK_email") || localStorage.getItem("DK_whatsapp")) &&
      localStorage.getItem("countdown")
      ? true
      : false,
  );
  const [showModal, setShowModal] = useState(false);
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState({
    email: "",
    otp: "",
  });
  const { t } = useTranslation();
  const [selected, setSelected] = useState("email");
  const navigate = useNavigate();
  const [isWebkit, setIsWebkit] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // sheet state
  const [sheetDetail, setSheetDetail] = useState({
    title: "",
    detail: "",
    open: false,
  });

  useEffect(() => {
    // Detect if the browser is a mobile browser
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileBrowser = /\b(iphone|ipad)\b/i.test(userAgent);
    setIsMobile(isMobileBrowser);
  }, []);

  useEffect(() => {
    if (selected === "whatsapp" && whatsappNum.length <= 0 && isSent) {
      setIsSent(false);
    } else if (selected === "email" && email.length <= 0 && isSent) {
      setIsSent(false);
    }
  }, [whatsappNum, email, isSent, selected]);

  useEffect(() => {
    // Detect if the browser is WebKit
    const isWebkitBrowser =
      "WebkitAppearance" in document.documentElement.style;
    setIsWebkit(isWebkitBrowser);
  }, []);

  useEffect(() => {
    if (otp.length === 4) {
      ConfirmOTP();
    }
  }, [otp]);

  // Function signin
  async function Signin(e) {
    e.preventDefault();
    setShowModalLoading(true);
    // Hit api for sent request otp
    const payload =
      selected === "email"
        ? {
            identifier: email.toLowerCase(),
            application: "WALLET",
            platform: "EMAIL",
          }
        : {
            identifier: `62${whatsappNum}`,
            application: "WALLET",
            platform: "WHATSAPP",
          };
    await requestAuthPost("auth/login", payload, { retry: true })
      .then((res) => {
        // make sure response success
        if (res.error) {
          setErrorMsg({ email: res.message[0] });
          toastNotify(res.message[0], "error");
        } else {
          if (!_.isEmpty(res)) {
            selected === "email"
              ? localStorage.setItem("DK_email", email.toLowerCase())
              : localStorage.setItem("DK_whatsapp", `62${whatsappNum}`);
            const newCountdown = Date.now() + 60000;
            setCounter(newCountdown);
            localStorage.setItem("countdown", Date.now() + 60000);
            setIsSent(true);
            setOtp("");
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    setShowModalLoading(false);
  }

  async function ConfirmOTP() {
    setShowModalLoading(true);
    const payload =
      selected === "email"
        ? {
            identifier: email.toLowerCase(),
            platform: "EMAIL",
            otp,
          }
        : {
            identifier: `62${whatsappNum}`,
            otp,
            platform: "WHATSAPP",
          };
    await requestAuthPost("auth/validate-otp", payload, { retry: true })
      .then(async (res) => {
        if (res.error === false) {
          const userLogin = res.data.data;
          const userOutlet = _.first(
            userLogin?.userOutlet?.filter((outlet) => outlet.isActive === true),
          );
          if (!userOutlet) {
            toastNotify("User not found or not have outlet", "error");
            navigate("/signin");
            return;
          } else {
            axios
              .get(`${process.env.REACT_APP_BASE_AUTH_URL_API}auth/me`, {
                headers: { Authorization: `Bearer ${userLogin.tokenUser}` },
              })
              .then((res) => {
                const addOnUser = res.data.data;
                if (
                  (userOutlet?.status === "INITIAL" &&
                    userOutlet?.userRole?.walletAdmin) ||
                  // TODO: delete dcm user condition when go live
                  (userOutlet?.status === "INITIAL" &&
                    userOutlet?.userRole?.roleName === "Wallet DCM User")
                ) {
                  localStorage.removeItem("countdown");
                  localStorage.removeItem("DK_email");
                  localStorage.removeItem("DK_whatsapp");
                  navigate("/register", {
                    state: {
                      user: userLogin,
                      outlet: userOutlet,
                      addOnUser,
                      token: userLogin.tokenUser,
                    },
                    replace: true,
                  });
                } else {
                  localStorage.setItem(
                    "dompet_user",
                    JSON.stringify(userLogin),
                  );
                  localStorage.setItem(
                    "dompet_detail_outlet",
                    JSON.stringify({
                      ...userOutlet,
                      retailer: addOnUser.outlet.retailer,
                    }),
                  );
                  localStorage.setItem("token_user", userLogin.tokenUser);
                  const expDate = new Date(userLogin.exp);
                  if (!isNaN(expDate.getTime())) {
                    expDate.setDate(expDate.getDate() - 1);
                    localStorage.setItem(
                      "token_expiration",
                      expDate.toISOString(),
                    );
                  }
                  localStorage.removeItem("countdown");
                  localStorage.removeItem("DK_email");
                  localStorage.removeItem("DK_whatsapp");
                  fetchAuthData();
                  navigate("/", { replace: true });
                }
              });
          }
        } else {
          setShowModalLoading(false);
          setOtp("");
          return toastNotify(res.message[0], "error");
        }
      })
      .catch((err) => {
        console.log(err);
        toastNotify(err?.data?.msg ?? "Something went wrong", "error");
        setOtp("");
        setShowModalLoading(false);
      });
  }

  return (
    <>
      <Helmet>
        <title>Sign In | Dompet Kartini</title>
      </Helmet>
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      <ModalBasic
        id="message-confirm-modal"
        modalOpen={showModal}
        setModalOpen={setShowModal}
        title="Confirm Message"
        enClose={true}
      >
        <div className="px-6 py-4">
          {isSent ? (
            <p className="text-gray-500">
              {t("signin.successOtp")}{" "}
              <span className="font-medium text-indigo-500">{email}</span>
            </p>
          ) : (
            <p className="text-gray-500">
              {t("signin.failedOtp")}{" "}
              <span className="font-medium text-indigo-500">{email}</span>
            </p>
          )}
        </div>
      </ModalBasic>
      <main className="bg-signin flex max-h-screen min-h-screen flex-col items-center justify-around">
        <div className="flex justify-center py-5">
          <SwitchLang />
        </div>
        <div className="block w-2/5  object-center md:hidden md:w-[10rem]">
          <img
            className="justify-self-center"
            src={LogoDompetKartini}
            alt="Kartini"
          />
          {width < 1024 && <DompetVersion />}
        </div>
        <div className="flex flex-col items-center justify-between px-5 pb-4 pt-8 md:grid md:grid-cols-2 md:px-12 ">
          <img
            className="hidden w-2/3 justify-self-center object-center md:block md:w-[10rem]"
            src={LogoDompetKartini}
            alt="Kartini"
          />
          <div className="flex flex-col gap-4 pr-0 md:pr-20">
            {/* Form */}
            <SigninTabs
              Signin={Signin}
              setEmail={setEmail}
              setWhatsappNum={setWhatsappNum}
              whatsappNum={whatsappNum}
              isSent={isSent}
              email={email}
              isValidEmail={isValidEmail}
              selected={selected}
              setSelected={setSelected}
              setOtp={setOtp}
              isLoading={showModalLoading}
              otp={otp}
              errorMsg={errorMsg}
              setErrorMsg={setErrorMsg}
              ConfirmOTP={ConfirmOTP}
              counter={counter}
              setCounter={setCounter}
            />
            <div className="text-center text-xs">
              <p className="text-monochrome-500">
                {t("signin.privacyText1")}{" "}
                <a
                  target="_blank"
                  href="https://www.kar-tini.com/privacy-policy"
                  rel="noreferrer"
                  className="text-soft-red-500"
                >
                  {t("signin.privacyPolicy")}{" "}
                </a>
                {t("signin.and")}{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.kar-tini.com/privacy-policy"
                  className="text-soft-red-500"
                >
                  {t("signin.privacyText2")}
                </a>{" "}
                {t("signin.privacyText3")}
              </p>
            </div>
          </div>
        </div>
        <div>
          <KartiniCopyright />
          {width > 1024 && <DompetVersion />}
        </div>
      </main>
      {/* Information Sheet */}
      <InformationSheet
        sheetDetail={sheetDetail}
        setSheetDetail={setSheetDetail}
      />
    </>
  );
};

export default withAuth(Signin, { protectedRoute: false });
